module.exports = __webpack_public_path__ + "static/2-1920x1280-08d0aa56718bd53df9639674e86846c4.jpg";